module.exports = __webpack_public_path__ + "static/media/1009827.be65248e.jpg";